import React from 'react';

import { Skeleton } from '@mui/material';

import { Nullable } from '@clearverify/types';

import { useEmployerLogoQuery } from 'src/api';

import { Avatar } from './Avatar';

type LoadableEmployerLogoProps = Omit<React.ComponentProps<typeof Avatar>, 'src'> & {
  employerId: Nullable<string>;
  size?: number;
};

export const LoadableEmployerLogo: React.FC<LoadableEmployerLogoProps> = ({
  employerId,
  size = 40,
  ...avatarProps
}) => {
  const { data, loading } = useEmployerLogoQuery({
    variables: { id: employerId! },
    skip: !employerId,
  });

  if (loading) {
    return <Skeleton width={size} height={size} sx={{ transform: 'none' }} />;
  }

  return <Avatar src={data?.employer?.logo} width={size} height={size} {...avatarProps} />;
};
